import React, { Component } from 'react'

import {config} from "./config"

import Avatar from '@material-ui/core/Avatar'
import LockIcon from '@material-ui/icons/LockOutlined'
import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import Button from '@material-ui/core/Button'

import ErrorMessageDialog from "./ErrorMessageDialog"

import withStyles from '@material-ui/core/styles/withStyles'

const styles = theme => ({
	screen: {
		marginTop: theme.spacing.unit * 2,
		display: 'flex',
	    flexDirection: 'column',
	    alignItems: 'center',
		padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
		[theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
	       width: 400,
	       marginLeft: 'auto',
	       marginRight: 'auto',
	    },
	},
	avatar: {
		margin: theme.spacing.unit,
		backgroundColor: theme.palette.secondary.main,
	},
	loginButton: {
		marginTop: theme.spacing.unit * 3,
	},
	registerButton: {
		marginTop: theme.spacing.unit * 1,
	},
})

/**
 * <RegisterScreen successHandle = {user} loginHandle = {user}/>
 */

class RegisterScreen extends Component {

	constructor(props) {
		super(props)

		this.state = {
			name: this.props.name || "",
			password: this.props.password || "",
			passwordAgain: this.props.passwordAgain || "",
			ErrorMessageDialog: this.props.ErrorMessageDialog,
		}
	}

	render() {
		const { classes } = this.props

		return <React.Fragment>
			<ErrorMessageDialog
				message = {this.state.ErrorMessageDialog}
				onClose = {() => {
					this.setState({ErrorMessageDialog: undefined})
				}}
			/>
			<main className = {classes.screen}>
				<Avatar className = {classes.avatar}>
					<LockIcon />
				</Avatar>
				<Typography component = "h1" variant = "h5">
					Регистрация
				</Typography>
				<form
					onSubmit = {
						e => {
							e.preventDefault()

							if (this.state.name === "" || !this.state.name) {
								this.setState({ErrorMessageDialog: "Введите имя пользователя"})
								return
							}

							if (this.state.password === "" || !this.state.password) {
								this.setState({ErrorMessageDialog: "Введите пароль"})
								return
							}

							if (this.state.password !== this.state.passwordAgain) {
								this.setState({ErrorMessageDialog: "Пароль и повтор пароля не совпадают"})
								return
							}

							let xhr = new XMLHttpRequest()
							xhr.open("POST", config.restApiHost + `/register`)
							xhr.onreadystatechange = ()=>{
								if (xhr.readyState === 4) {
									if (xhr.status === 200) {
										let json = JSON.parse(xhr.responseText)
										document.cookie = `${config.region.prefix}_sid=${json["sid"]};path=/;expires=Fri, 31 Dec 9999 23:59:59 GMT`
										this.props.successHandle({
											sid: json["sid"],
											name: this.state.name,
											password: this.state.password
										})
									} else {
										let json = JSON.parse(xhr.responseText)
										this.setState({
											ErrorMessageDialog: json.message
										})
									}
								}
							}
							xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8")
							xhr.send(JSON.stringify({
								name: this.state.name,
								password: this.state.password
							}))
						}
					}
				>

					<FormControl margin = "normal" fullWidth>
						<InputLabel htmlFor = "name">Имя пользователя</InputLabel>
						<Input
							id = "name"
							name = "name"
							autoComplete = "name"
							autoFocus
							value = {this.state.name}
							onChange = {e => {
								this.setState({
									name: e.target.value
								})
							}}
						/>
					</FormControl>

					<FormControl margin = "normal" fullWidth>
						<InputLabel htmlFor = "password">Пароль</InputLabel>
						<Input
							name = "password"
							type = "password"
							id = "password"
							autoComplete = "current-password"
							value = {this.state.password}
							onChange = {e => {
								this.setState({
									password: e.target.value
								})
							}}
						/>
					</FormControl>

					<FormControl margin = "normal" fullWidth>
						<InputLabel htmlFor = "passwordAgain">Пароль еще раз</InputLabel>
						<Input
							name = "passwordAgain"
							type = "password"
							id = "passwordAgain"
							value = {this.state.passwordAgain}
							onChange = {e => {
								this.setState({
									passwordAgain: e.target.value
								})
							}}
						/>
					</FormControl>

					<Button
						type = "submit"
						fullWidth
						variant = "contained"
						color = "primary"
						className = {classes.loginButton}
		            >
						Регистрация
		            </Button>

					<Button
						color="primary"
						className={classes.registerButton}
						fullWidth
						onClick = {
							e => {
								e.preventDefault();
								this.props.loginHandle({
									name: this.state.name,
									password: this.state.password
								})
							}
						}
					>
						Вход
					</Button>

				</form>
			</main>
		</React.Fragment>
	}

}

export default withStyles(styles)(RegisterScreen)
